var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-immunizations.6530709d.png","uri@2x": __webpack_public_path__ + "icon-immunizations.df88fd38.png","uri@3x": __webpack_public_path__ + "icon-immunizations.aeaab259.png",
    width: 32,
    height: 30
});